import { ListeTable } from '@mairistem/liste';
import React from 'react';
import type { FluxPesEnAttente } from '../../services/pes/importPes';
import { dateCourte, taille } from '../../utils/pes/format';

interface FluxEnAttenteRowProps {
	item: FluxPesEnAttente;
	selectedItem: number | undefined;
}

/** Ligne de la liste des fichiers en attente (FluxEnAttenteModal), en vert quand elle est choisie. */
const FluxEnAttenteRow = ({ item, selectedItem }: FluxEnAttenteRowProps) => (
	<ListeTable.Row positive={item.identifiant === selectedItem}>
		<ListeTable.Cell name="codeSrc">{item.codeSrc}</ListeTable.Cell>
		<ListeTable.Cell name="nom">{item.nom}</ListeTable.Cell>
		<ListeTable.Cell name="dateCreation">
			{dateCourte(item.dateCreation)}
		</ListeTable.Cell>
		<ListeTable.Cell name="taille">{taille(item.taille)}</ListeTable.Cell>
	</ListeTable.Row>
);

export default FluxEnAttenteRow;
